import { Link } from "react-router-dom";
import { HelpCircle } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "components/ui/accordion";
import { Button } from "components/ui/button";
import { faqPreviewItems } from "content/faqContent";

export function FaqPreviewSection() {
  return (
    <section className="py-16 sm:py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12 xl:px-16">
        <div className="mx-auto max-w-3xl">
          <div className="mb-8 flex items-center justify-center gap-2 text-center">
            <HelpCircle className="h-6 w-6 text-accent" aria-hidden />
            <h2 className="text-2xl font-bold tracking-tight sm:text-3xl">
              Frequently Asked Questions
            </h2>
          </div>

          <Accordion type="single" collapsible className="w-full">
            {faqPreviewItems.map((faq, index) => (
              <AccordionItem key={faq.question} value={`faq-preview-${index}`}>
                <AccordionTrigger className="text-left text-base">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-8 text-center">
            <Button variant="outline" asChild>
              <Link to="/faq">View all FAQs</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
